import React from "react";
import { Redirect } from "react-router-dom";

export default function LicensePage() {
  return <Redirect to="/applications/licensing/agent-info"/>;  
}
